import type { DataLayerInfo, PageInfo } from '../../../../shared/types'

export const getHubSubVerticalDataLayer = (pageInfo: PageInfo) => {
  const hubDataLayer: DataLayerInfo = {
    ...pageInfo,
    tags: pageInfo.sub_vertical,
    content_type: 'news',
    pageType: 'news-hub',
  }

  // WHC-1189: Add specific content_tags for topic pensions hub page
  // (https://www.which.co.uk/topic/pensions-and-retirement)
  if (pageInfo.vertical === 'topic' && pageInfo.sub_vertical === 'pensions-and-retirement') {
    hubDataLayer.tags += ' | pensions tertiary journeys'
  }

  delete hubDataLayer.vertical
  delete hubDataLayer.sub_vertical

  return hubDataLayer
}
